/**
 * API Configuration
 *
 * All API endpoints are configured via environment variables set at build time.
 * NO environment detection or conditionals in the frontend for security.
 *
 * Jenkins/Terraform must set these variables appropriately per environment:
 * - AAT: Points to mock APIs
 * - DEV/SANDBOX/STAGING/PROD: Points to real APIs
 */

/**
 * Catalog Microservices API Configuration
 *
 * Build-time environment variable determines the endpoint:
 * - AAT env: Jenkins sets to mock API (e.g., https://xxxxx.execute-api.us-west-2.amazonaws.com/test)
 * - Other envs: Jenkins sets to real API (e.g., https://eadvs-cscc-catalog-api.apps.asu.edu)
 */
export const CATALOG_API_CONFIG = {
  baseUrl:
    process.env.REACT_APP_CATALOG_API_URL || process.env.REACT_APP_API_ENDPOINT,
  subjectsPath: '/catalog-microservices/api/v1/search/subjects',
};

/**
 * Data Potluck (DPL) API Configuration
 *
 * Build-time environment variable determines the endpoint:
 * - AAT env: Could point to mock (when implemented)
 * - Other envs: Points to real DPL API
 */
export const DPL_API_CONFIG = {
  baseUrl:
    process.env.REACT_APP_DPL_BASE_URL ||
    'https://api.myasuplat-dpl.asu.edu/api',
};

/**
 * Helper function to get the full API URL
 */
export function getApiUrl(config, path) {
  return `${config.baseUrl}${path}`;
}

const apiConfig = {
  CATALOG_API_CONFIG,
  DPL_API_CONFIG,
  getApiUrl,
};

export default apiConfig;
